import { createMuiTheme } from '@material-ui/core'

export default createMuiTheme({
    palette: {
        type: 'light',
        primary: {
            main: '#F22F46',
        },
    },
    spacing: 4,
    sidebarWidth: 260,
    sidebarMobileHeight: 90,
    typography: {
        fontFamily: `"Avenir"`,
    },
})
